import {
  ProjectActionType,
  ProjectByLastWeekAction,
  IProjectByLastWeekState,
} from "../types/projectDataSQP"

const initialState: IProjectByLastWeekState = {
  projectDataSQPByLastWeek: {},
  loading: false,
  error: null,
}

export const projectDataByLastWeekReducer = (
  state: IProjectByLastWeekState = initialState,
  action: ProjectByLastWeekAction
): IProjectByLastWeekState => {
  switch (action.type) {
    case ProjectActionType.FETCH_PROJECT_DATA_SQP_BY_LAST_WEEK:
      return { ...state, loading: true }
    case ProjectActionType.FETCH_PROJECT_DATA_SQP_SUCCESS_BY_LAST_WEEK:
      const newProjectDataSqpByLastWeek = { ...state.projectDataSQPByLastWeek }

      for (const [searchTerm, data] of Object.entries(action.payload)) {
        if (state.projectDataSQPByLastWeek[searchTerm]) {
          newProjectDataSqpByLastWeek[searchTerm] = [
            ...state.projectDataSQPByLastWeek[searchTerm],
            ...data,
          ]
        } else {
          newProjectDataSqpByLastWeek[searchTerm] = [...data]
        }
      }

      return { ...state, projectDataSQPByLastWeek: newProjectDataSqpByLastWeek, loading: false }
    case ProjectActionType.FETCH_PROJECT_DATA_SQP_ERROR_BY_LAST_WEEK:
      return { ...state, error: action.payload, loading: false }
    default:
      const exhaustiveCheck: never = action
      return state
  }
}

export default projectDataByLastWeekReducer
